import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

export default function Hero() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const parallax = Math.min(scrollY * 0.35, 240);

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen overflow-hidden"
      style={{ backgroundColor: "var(--aq-navy-deep)" }}
    >
      <img
        src="/brand/aquarius_hero_ocean.jpg"
        alt="Aquarius — a 55-foot light-blue Hatteras sportfishing convertible chasing marlin off Ocho Rios at sunset"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ transform: `translate3d(0, ${parallax}px, 0) scale(1.08)`, transition: "transform 200ms linear" }}
      />
      <div className="absolute inset-0 aq-hero-overlay" />

      <div className="relative aq-container min-h-screen flex flex-col justify-center pt-32 pb-20" style={{ color: "var(--aq-foam)" }}>
        <span className="aq-overline" data-testid="hero-overline">Ocho Rios · Jamaica</span>
        <h1
          className="aq-h1 mt-6 text-5xl sm:text-6xl lg:text-7xl"
          data-testid="hero-headline"
          style={{ maxWidth: 920 }}
        >
          Charter <em style={{ fontStyle: "italic", color: "var(--aq-gold-warm)" }}>Aquarius</em>
          <br />
          for sport fishing in Jamaica.
        </h1>
        <p
          className="mt-7 text-base sm:text-lg max-w-xl"
          data-testid="hero-subhead"
          style={{ color: "rgba(246, 244, 238, 0.86)", fontWeight: 300, lineHeight: 1.65 }}
        >
          A 55-foot Hatteras convertible running deep-sea charters out of Ocho Rios Marina —
          twin 650 HP diesels, full crew, marlin and tuna country.
        </p>

        <div className="mt-7 inline-flex items-center gap-2" style={{ color: "rgba(246,244,238,0.85)" }}>
          <span style={{ display: "inline-flex", gap: 2 }} aria-hidden>
            {[1,2,3,4,5].map((i) => (
              <span key={i} style={{ color: "var(--aq-gold-warm)", fontSize: 16 }}>★</span>
            ))}
          </span>
          <span className="text-sm" data-testid="hero-rating">4.8 · 53 reviews on FishingBooker</span>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <a href="#trips" data-testid="hero-book-cta" className="aq-btn-primary">
            Book Your Charter
          </a>
          <a href="#vessel" data-testid="hero-explore-cta" className="aq-btn-ghost">
            Explore the Vessel
          </a>
        </div>

        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-80" style={{ color: "var(--aq-foam)" }}>
          <span className="aq-overline" style={{ fontSize: 9 }}>Scroll</span>
          <ChevronDown size={20} className="animate-bounce" style={{ animationDuration: "2.4s" }} />
        </div>
      </div>
    </section>
  );
}
